<template>
  <div>
    <!-- PinModal component - opens directly without intermediate dialog -->
    <pin-modal
      ref="pinModal"
      @pin-submitted="handlePinSubmitted"
    ></pin-modal>
  </div>
</template>

<script>
import { df } from '@/plugins/firebase'
import state from '@/state'
import EventBus from '@/plugins/event-bus'
import PinModal from '@/components/PinModal.vue'

export default {
  components: {
    PinModal
  },
  props: ['toolbar', 'confirmDisabled'],
  inject: ['showMsgBox'],
  data: () => ({
    templatesDialogOpen: false,
    selectedUser: '',
    selectedTable: null,
    users: [],
    scrollable: false,
    confirmDis: true,
    cashReg: {}
  }),
  methods: {
    open (users, cashReg, selectedTable) {
      users.forEach(user => {
        this.users.push(user.user)
      })
      this.cashReg = cashReg
      this.selectedTable = selectedTable

      // Open PIN modal directly
      this.$nextTick(() => {
        this.$refs.pinModal.openModal()
      })
    },
    close () {
      this.selectedUser = ''
      this.users = []
      // Close PIN modal if open
      if (this.$refs.pinModal) {
        this.$refs.pinModal.closeModal()
      }
    },
    handlePinSubmitted (pincode) {
      // Find user with matching PIN
      let foundUser = null
      this.users.forEach(user => {
        if (user.pincode !== undefined && user.pincode !== '' && user.pincode !== null && user.pincode === pincode) {
          foundUser = user
        }
      })

      if (foundUser && foundUser.id !== '' && this.selectedTable.id !== '') {
        this.selectedUser = foundUser
        this.updateTable()
        // Close PIN modal on success
        this.$refs.pinModal.closeModal()
      } else {
        this.showMsgBox({
          text: 'Na blagajni nema korisnika sa tim PIN-om, molimo pokušajte ponovno.',
          actions: ['cancel'],
          cancelBtnText: this.$t('$vuetify.close'),
          color: 'error'
        })

        // Reopen PIN modal for retry
        this.$nextTick(() => {
          this.$refs.pinModal.openModal()
        })
      }
    },

    async updateTable () {
      const tbl = this.selectedTable
      if (tbl) {
        df.doc(`location_orders/${state.getPointOfSale().id}/tables/${tbl.id}`).update({
          // locked_by: this.selectedUser.id,
          user_id: this.selectedUser.id,
          user_name: this.selectedUser.name + ' ' + this.selectedUser.surname
        })
          .then(() => {
            console.info('Table succesfully updated.')
            EventBus.$emit('clear-reload-tables')
          })
          .catch(() => {
            console.error('Table has not been updated succesfully.')
          })
      }
    }
  }
}
</script>

<style scoped>
/* No custom styles needed - using PinModal component */
</style>
